import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import { useNavigate, useSearchParams } from "react-router-dom";
import { makePostRequest } from "../utils/api";
import { urls } from "../utils/urls";
import Container from "react-bootstrap/esm/Container";

function PasswordResetConfirm() {
  const [formErrors, setFormErrors] = useState(false);

  const [errorText, setErrorText] = useState("");
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const token = searchParams.get("token");

  const [userData, setUserData] = useState({
    password: "",
    password_c: "",
    token: token,
  });

  const handlePass = (e) => {
    setUserData((userData) => {
      return { ...userData, password: e.target.value };
    });
  };

  const handlePass_c = (e) => {
    setUserData(() => {
      return { ...userData, password_c: e.target.value };
    });
  };

  const handlePasswordReset = async (data) => {
    data.preventDefault();
    setFormErrors(false);

    if (userData.password_c === "") {
      setErrorText(`Please confirm your password.`);
      setFormErrors(true);
    }
    if (userData.password === "") {
      setErrorText(`Please enter an password.`);
      setFormErrors(true);
    }

    console.log(urls.passwordConfirm);

    if (userData.password !== "") {
      if (userData.password === userData.password_c) {
        const response = await makePostRequest(
          urls.passwordConfirm,
          userData,
          {}
        );
        if (response.status !== 200) {
          setFormErrors(true);
          setErrorText(response.password);
        }
        if (response.status === 200) {
          setFormErrors(true);
          setErrorText(
            `Thank you for using our password reset utility. Your password has been successfully reset. Please login here: https://GeriActive.life/login`
          );
        }
      } else {
        setErrorText(`Please ensure that both passwords are the same.`);
        setFormErrors(true);
      }
    }
  };

  return (
    <Container
      style={{
        display: "flex",
        alignItems: "center",
        textAlign: "left",
        minHeight: window.innerHeight - 40,
      }}
    >
      <Card
        style={{
          width: "500px",
          margin: "auto",
          padding: "25px",
          verticalAlign: "middle",
        }}
      >
        <Form onSubmit={handlePasswordReset}>
          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Password"
              onChange={handlePass}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>Confim Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Password"
              onChange={handlePass_c}
            />
          </Form.Group>
          {formErrors ? (
            <Card style={{ marginBottom: "15px" }}>
              <Card.Body style={{ color: "red", fontSize: "12px" }}>
                {errorText}
              </Card.Body>
            </Card>
          ) : (
            ""
          )}
          <Button variant="primary" type="submit">
            Submit
          </Button>
        </Form>
      </Card>
    </Container>
  );
}

export default PasswordResetConfirm;
